import { render, staticRenderFns } from "./report-br.vue?vue&type=template&id=92c433ae&scoped=true&"
import script from "./report-br.vue?vue&type=script&lang=ts&"
export * from "./report-br.vue?vue&type=script&lang=ts&"
import style0 from "./report-br.vue?vue&type=style&index=0&id=92c433ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c433ae",
  null
  
)

export default component.exports